export default __webpack_public_path__ + "images/A3.7ed0b2f.png";